import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';

@Pipe({
  name: 'sxDateTime',
  pure: true,
  standalone: false,
})
export class DateTimePipe implements PipeTransform {
  constructor(private date: DatePipe) {}

  transform(value: any, displayWhenNotVailable?): any {
    return value ? moment(value).format('DD.MM.YYYY - hh:mm:ss') : displayWhenNotVailable || '';
  }
}
